<div class="rights_top">

  <div class="log">
    <h2 class="title" style="font-size: .8vw; font-weight: bold;">Acquisition > Report</h2>
  </div>

  <div class="filter_search">
    <div class="search_container">
      <input type="text" #search class="default_input search search_land" placeholder="Search" />
      <em class="ti-search"></em>
    </div>
    <button class="default_secondary-btn Add_new" (click)="onFilter()">Advanced Search</button>
  </div>
</div>

<div class="main_form" *ngIf="task === 'list' && view === 'mainSearch' && isFilter">

  <mat-accordion>

    <mat-expansion-panel  hideToggle #example2 [(expanded)]="isExpanded" class="mat-elevation-z10" >
    <mat-expansion-panel-header class="mat-expan">
    <mat-panel-title >
    <h3 class="header"> Search Criteria</h3>
    </mat-panel-title>
    <em class="ti-arrow-circle-down" style="font-size: 2.5rem;" *ngIf="!example2.expanded"></em>
    <em class="ti-arrow-circle-right" style="font-size: 2.5rem;" *ngIf="example2.expanded"></em>


    </mat-expansion-panel-header>
    <form [formGroup]="searchCriteriaForm">
    <div class="the_card">


      <div class="rights_forms">

        <div class="the_input">
          <label for="">Group</label>
          <select
          (change)="onFilterSubGroup($event.target.value)"
          formControlName="Group"
          class="default_input">
          <option value="">Select Item</option>
            <option *ngFor="let group of groups" [value]="group.id">{{
              group.GroupName
            }}</option>
          </select>
        </div>
        <div class="the_input">
          <label for="">Sub Group</label>
          <select  (change)="onFilterSubSubGroup($event.target.value)"  formControlName="SubGroup" class="default_input">
            <option value="">Select Item</option>
            <option *ngFor="let subGroup of filterSubGroup"
            [value]="subGroup.id">{{ subGroup.SubGroupName }}</option>
          </select>
        </div>
        <div class="the_input">
          <label for="">Sub-Sub Group</label>
          <select  (change)="onSelectSubSubGroupId($event.target.value)"  formControlName="SubSubGroup" class="default_input">
            <option value="">Select Item</option>
            <option  *ngFor="let subSubGroup of filterSubSubGroup"
            [value]="subSubGroup.id">{{ subSubGroup.SubSubGroupName }}</option>
          </select>
        </div>
        <div class="the_input">
          <label for="">Acquisition Type</label>
          <select  formControlName="AcquisitionType" class="default_input">
            <option value="">Select Item</option>
            <option *ngFor="let acquisitionType of acquisitionTypes" [value]="acquisitionType.id">{{
              acquisitionType.AcquisitionTypeName
            }}</option>
          </select>
        </div>
        <div class="the_input">
          <label for="">C-of-O</label>
          <select formControlName="CofOStatusId" class="default_input">
            <option value="">Select C-of-O</option>
            <option *ngFor="let status of cofOStatus"
            [value]="status.id">{{ status.CofOStatusName }}</option>
          </select>
        </div>


        <!-- <button class="default_secondary-btn" (click)="onViewRange()">View Range</button> -->
      </div>

      <div class="mode">
        <!-- <span class="radio_check">
          <input type="radio" value="bulk" name="paymentMethod" (change)="onPaymentMethod($event.target.value)" />
          Bulk Data Processing
        </span>
        <span class="radio_check">
          <input type="radio" value="individual" name="paymentMethod" (change)="onPaymentMethod($event.target.value)"/>
          Individual Data Processing
        </span>
        <span class="radio_check">
          <input type="radio" value="beneficiaries" name="paymentMethod" (change)="onPaymentMethod($event.target.value)"/>
          Assign Beneficiaries
        </span> -->
        <!-- <div class="call" *ngIf="isViewRange">
          <div class="the_input">
            <label for="">FirstCall Date</label>
            <input type="date"  formControlName="FirstCallDate" class="default_input" />
          </div>
          <div class="the_input">
            <label for="">LastCall Date</label>
            <input type="date"  formControlName="LastCallDate" class="default_input" />
          </div>
        </div> -->
      </div>

      <div class="down">
        <button class="default_primary-button" type="submit" (click)="onSearch(searchCriteriaForm.value)">Search</button>
      </div>

    </div>
  </form>
    </mat-expansion-panel>
    </mat-accordion>

</div>

